import React from "react";
import { observer, inject } from "mobx-react";
import { NavLink, withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { MenuOperators, MenuItemOperators } from "ComponentsUI/Navigation";
const Routes = require("Configs/routes");

import {
	OPERATOR_TAB_CARD,
	OPERATOR_TAB_TARIFFS,
	OPERATOR_TAB_BEAUTIFUL_NUMBERS,
	OPERATOR_TAB_ACTIONS,
} from "stores/OperatorModel";
import v4 from "uuid/v4";

const SubMenuOperatorContainer = (props) => {
	const operatorModel = props.ApplicationModel.operatorModel;
	const text = props.ApplicationModel.text;

	const operatorCardUrl = generateUrl(Routes.OperatorDetails.route, {
		regionUrl: props.match.params.regionUrl,
		operator: props.match.params.operator,
	});

	const operatorTariffsUrl = generateUrl(Routes.OperatoryTariffs.route, {
		regionUrl: props.match.params.regionUrl,
		operator: props.match.params.operator,
	});

	const operatorBeautifulNumbersUrl = generateUrl(Routes.OperatoryBeautifulNumbers.route, {
		regionUrl: props.match.params.regionUrl,
		operator: props.match.params.operator,
	});

	const operatorActionsUrl = generateUrl(Routes.OperatoryActions.route, {
		regionUrl: props.match.params.regionUrl,
		operator: props.match.params.operator,
	});

	let providerTagUrl;
	if (!!props.providerTag)
		providerTagUrl = generateUrl(Routes.ProviderRatesTags.route, {
			regionUrl: props.match.params.regionUrl,
			providerName: props.providerTag.url_name,
			tagCode: "internet-tv-mobile",
		});

	const menuItems = [
		{
			name: text.ABOUT_OPERATOR_MENU,
			url: {
				pathname: operatorCardUrl,
				search: props.location.search,
			},
			key: OPERATOR_TAB_CARD,
		},
	];

	menuItems.push({
		name: text.menuRates,
		url: {
			pathname: operatorTariffsUrl,
			search: props.location.search,
		},
		key: OPERATOR_TAB_TARIFFS,
	});

	menuItems.push({
		name: text.NUMBERS,
		url: {
			pathname: operatorBeautifulNumbersUrl,
			search: props.location.search,
		},
		key: OPERATOR_TAB_BEAUTIFUL_NUMBERS,
	});

	const {
		info: { cnt_action_tariffs, cnt_news },
	} = props.operatorForCard;

	if (cnt_action_tariffs || cnt_news) {
		menuItems.push({
			name: text.menuActions,
			url: {
				pathname: operatorActionsUrl,
				search: props.location.search,
			},
			key: OPERATOR_TAB_ACTIONS,
		});
	}

	const items = menuItems.map((item, index) => {
		return (
			<MenuItemOperators
				isProviderMenu={true}
				isActive={operatorModel.visibleTab === item.key}
				key={index}
				counter={item.counter}
				onlyLg={item.onlyLg}
				providerTheme={true}
				purpleColor={true}
			>
				<NavLink
					onClick={() => operatorModel.changeTab(item.key)}
					to={item.url}
					datatest={item.datatest}
					exact={index === 0}
				>
					{item.name}
				</NavLink>
			</MenuItemOperators>
		);
	});

	if (!!props.providerTag) {
		items.push(
			<MenuItemOperators
				isProviderMenu={true}
				isActive={false}
				key={v4()}
				providerTheme={true}
				purpleColor={true}
			>
				<NavLink to={providerTagUrl} datatest={"provider_tag_internet-tv-mobile"} exact={true}>
					{text.three_in_one}
				</NavLink>
			</MenuItemOperators>
		);
	}

	return <MenuOperators providerTheme={true} items={items} />;
};

export default withRouter(inject("ApplicationModel")(observer(SubMenuOperatorContainer)));
